import { useTranslation } from 'react-i18next';

import { DashboardProjectCardHeaderContent } from '@/features/dashboard/components/dashboard/dashboard-project-card-header-content';
import { EmptyTablePlaceholderContent } from '@/shared/components/table/empty-table-placeholder';
import { Card, CardContent, CardHeader } from '@/shared/components/ui/card';
import { ProjectWithContractors } from '@/shared/types/api';

export const NoKpisProjectCard = ({
  project,
}: {
  project: ProjectWithContractors;
}) => {
  const { t } = useTranslation('overview', {
    keyPrefix: 'OverviewPage.emptyProjectSlideCards',
  });

  return (
    <Card variant="informationAlt" className="size-full p-0">
      <CardHeader className="flex flex-row items-start justify-between p-6">
        <DashboardProjectCardHeaderContent
          kpiName={undefined}
          projectName={project.name}
        />
      </CardHeader>
      <CardContent className="flex h-full items-center justify-center px-7">
        <EmptyTablePlaceholderContent
          className="w-full p-0"
          title={t('title')}
          description={t('description')}
          centered
        />
      </CardContent>
    </Card>
  );
};
